(function() {
  'use strict';

  // Handle Mailchimp form submission and responses
  const initMailchimpForms = () => {
    const forms = document.querySelectorAll('.mailchimp-form');
    
    forms.forEach(form => {
      const errorResponse = form.querySelector('#mce-error-response');
      const successResponse = form.querySelector('#mce-success-response');
      const emailInput = form.querySelector('input[type="email"]');
      
      // Check URL parameters for Mailchimp response
      const urlParams = new URLSearchParams(window.location.search);
      const subscribe = urlParams.get('subscribe');
      
      if (subscribe === 'success') {
        if (successResponse) {
          successResponse.style.display = 'block';
          form.reset();
          // Scroll to success message
          successResponse.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      } else if (subscribe === 'error') {
        if (errorResponse) {
          const errorMessage = urlParams.get('message') || 'An error occurred. Please try again.';
          const errorText = errorResponse.querySelector('.error-message');
          if (errorText) {
            errorText.textContent = errorMessage;
          }
          errorResponse.style.display = 'block';
          if (emailInput) {
            emailInput.focus();
          }
        }
      }
      
      // Handle form submission
      form.addEventListener('submit', function(e) {
        // Clear previous messages
        if (errorResponse) {
          errorResponse.style.display = 'none';
        }
        if (successResponse) {
          successResponse.style.display = 'none';
        }
        
        // Basic email validation
        if (emailInput && !emailInput.validity.valid) {
          e.preventDefault();
          if (errorResponse) {
            const errorText = errorResponse.querySelector('.error-message');
            if (errorText) {
              errorText.textContent = 'Please enter a valid email address.';
            }
            errorResponse.style.display = 'block';
            emailInput.focus();
          }
          return false;
        }
        
        // If using embed code, let Mailchimp handle it
        // Otherwise, form will submit normally to Mailchimp action URL
      });
    });
  };

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMailchimpForms);
  } else {
    initMailchimpForms();
  }

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', initMailchimpForms);
})();

